import { ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function RegimeViewToggle({ value, onChange }) {
    const theme = useTheme()

    return (
        <ToggleButtonGroup
            exclusive
            value={value}
            onChange={handleChange}
            data-cy="regime-view-toggle"
            sx={{
                gap: 0.5,
                height: theme.spacing(5),
                p: 0.25,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: `${theme.shape.borderRadius}px`,
                "& .MuiToggleButtonGroup-grouped": {
                    m: 0,
                    p: 0,
                    width: theme.spacing(5),
                    height: 1,
                    border: 0,
                    borderRadius: `${theme.shape.borderRadius}px !important`,
                    color: "text.secondary",
                    "&.Mui-selected, &.Mui-selected:hover": {
                        bgcolor: "sfg20.light",
                        color: "primary.main",
                    },
                },
            }}
        >
            <ToggleButton value="card" aria-label="Card view" data-cy="regime-view-card">
                <Iconify icon="lets-icons:widget" sx={{ width: theme.spacing(3), height: theme.spacing(3) }} />
            </ToggleButton>
            <ToggleButton value="table" aria-label="Table view" data-cy="regime-view-table">
                <Iconify icon="meteor-icons:list" sx={{ width: theme.spacing(3), height: theme.spacing(3) }} />
            </ToggleButton>
        </ToggleButtonGroup>
    )

    function handleChange(_event, next) {
        if (!next) return
        onChange(next)
    }
}
